/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

import africa_comparative from './examples-africa-comparative.js'
import africa_diaspora from './examples-africa-diaspora.js'
import africa_diaspora_music from './examples-africa-diaspora-music.js'
import africa_ghana from './examples-africa-ghana.js'
import africa_guinea from './examples-africa-guinea.js'
import africa_mali from './examples-africa-mali.js'
import africa_nigeria from './examples-africa-nigeria.js'
import asia_china from './examples-asia-china.js'
import asia_comparative from './examples-asia-comparative.js'
import asia_diaspora from './examples-asia-diaspora.js'
import asia_japan from './examples-asia-japan.js'
import asia_korea from './examples-asia-korea.js'
import asia_mainland_se from './examples-asia-mainland-se.js'
import asia_mongolia from './examples-asia-mongolia.js'
import british_comparative from './examples-british-comparative.js'
import british_diaspora from './examples-british-diaspora.js'
import british_england from './examples-british-england.js'
import british_morris from './examples-british-morris.js'
import british_northumbria from './examples-british-northumbria.js'
import british_song from './examples-british-song.js'
import celtic_brittany from './examples-celtic-brittany.js'
import celtic_comparative from './examples-celtic-comparative.js'
import celtic_diaspora from './examples-celtic-diaspora.js'
import celtic_ireland from './examples-celtic-ireland.js'
import celtic_scotland from './examples-celtic-scotland.js'
import celtic_wales from './examples-celtic-wales.js'
import east_balkans from './examples-east-balkans.js'
import east_baltic from './examples-east-baltic.js'
import east_comparative from './examples-east-comparative.js'
import east_diaspora from './examples-east-diaspora.js'
import east_hungary from './examples-east-hungary.js'
import east_klezmer from './examples-east-klezmer.js'
import east_poland from './examples-east-poland.js'
import french_acadian from './examples-french-acadian.js'
import french_basque from './examples-french-basque.js'
import french_comparative from './examples-french-comparative.js'
import french_diaspora from './examples-french-diaspora.js'
import french_louisiana_cajun from './examples-french-louisiana-cajun.js'
import french_occitan from './examples-french-occitan.js'
import french_quebec from './examples-french-quebec.js'
import iberian_asturias from './examples-iberian-asturias.js'
import iberian_castile_catalan from './examples-iberian-castile-catalan.js'
import iberian_comparative from './examples-iberian-comparative.js'
import iberian_diaspora from './examples-iberian-diaspora.js'
import iberian_flamenco from './examples-iberian-flamenco.js'
import iberian_galicia from './examples-iberian-galicia.js'
import iberian_portugal from './examples-iberian-portugal.js'
import latin_andes from './examples-latin-andes.js'
import latin_brazil from './examples-latin-brazil.js'
import latin_caribbean from './examples-latin-caribbean.js'
import latin_comparative from './examples-latin-comparative.js'
import latin_diaspora from './examples-latin-diaspora.js'
import latin_mexico from './examples-latin-mexico.js'
import latin_southern_cone from './examples-latin-southern-cone.js'
import me_comparative from './examples-me-comparative.js'
import me_diaspora from './examples-me-diaspora.js'
import me_greece from './examples-me-greece.js'
import me_levant from './examples-me-levant.js'
import me_maghreb from './examples-me-maghreb.js'
import me_persia from './examples-me-persia.js'
import me_turkey from './examples-me-turkey.js'
import nordic_comparative from './examples-nordic-comparative.js'
import nordic_denmark from './examples-nordic-denmark.js'
import nordic_diaspora from './examples-nordic-diaspora.js'
import nordic_finland from './examples-nordic-finland.js'
import nordic_islands from './examples-nordic-islands.js'
import nordic_norway from './examples-nordic-norway.js'
import nordic_sami from './examples-nordic-sami.js'
import nordic_sweden from './examples-nordic-sweden.js'
import roots_appalachia from './examples-roots-appalachia.js'
import roots_bluegrass from './examples-roots-bluegrass.js'
import roots_cajun from './examples-roots-cajun.js'
import roots_comparative from './examples-roots-comparative.js'
import roots_contra from './examples-roots-contra.js'
import roots_diaspora from './examples-roots-diaspora.js'
import roots_quebec from './examples-roots-quebec.js'
import south_bengal from './examples-south-bengal.js'
import south_carnatic from './examples-south-carnatic.js'
import south_comparative from './examples-south-comparative.js'
import south_diaspora from './examples-south-diaspora.js'
import south_hindustani from './examples-south-hindustani.js'
import south_india_folk from './examples-south-india-folk.js'
import south_northwest from './examples-south-northwest.js'

export default Object.assign(
  {},
  africa_comparative,
  africa_diaspora,
  africa_diaspora_music,
  africa_ghana,
  africa_guinea,
  africa_mali,
  africa_nigeria,
  asia_china,
  asia_comparative,
  asia_diaspora,
  asia_japan,
  asia_korea,
  asia_mainland_se,
  asia_mongolia,
  british_comparative,
  british_diaspora,
  british_england,
  british_morris,
  british_northumbria,
  british_song,
  celtic_brittany,
  celtic_comparative,
  celtic_diaspora,
  celtic_ireland,
  celtic_scotland,
  celtic_wales,
  east_balkans,
  east_baltic,
  east_comparative,
  east_diaspora,
  east_hungary,
  east_klezmer,
  east_poland,
  french_acadian,
  french_basque,
  french_comparative,
  french_diaspora,
  french_louisiana_cajun,
  french_occitan,
  french_quebec,
  iberian_asturias,
  iberian_castile_catalan,
  iberian_comparative,
  iberian_diaspora,
  iberian_flamenco,
  iberian_galicia,
  iberian_portugal,
  latin_andes,
  latin_brazil,
  latin_caribbean,
  latin_comparative,
  latin_diaspora,
  latin_mexico,
  latin_southern_cone,
  me_comparative,
  me_diaspora,
  me_greece,
  me_levant,
  me_maghreb,
  me_persia,
  me_turkey,
  nordic_comparative,
  nordic_denmark,
  nordic_diaspora,
  nordic_finland,
  nordic_islands,
  nordic_norway,
  nordic_sami,
  nordic_sweden,
  roots_appalachia,
  roots_bluegrass,
  roots_cajun,
  roots_comparative,
  roots_contra,
  roots_diaspora,
  roots_quebec,
  south_bengal,
  south_carnatic,
  south_comparative,
  south_diaspora,
  south_hindustani,
  south_india_folk,
  south_northwest,
)
